var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-6-desktop is-offset-3-desktop is-8-tablet is-offset-2-tablet is-10-mobile is-offset-1-mobile"},[_c('h2',{staticClass:"subtitle"},[_vm._v("logging out...")]),_c('div',[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-3x fa-fw"})])])])
}]

export { render, staticRenderFns }